// Accordion Toggles
import {
  addClass,
  childOf,
  event,
  hasClass,
  removeClass,
  selectArr,
  selectDoc,
  toggleClass
} from "../utils/utils";

import {toggleMiniCart} from "../components/component.minicart";
import {toggleMiniAccount} from "../components/component.miniaccount";
import {toggleSearch} from "../components/component.nav";

class Accordion {
  constructor() {
    this.mql = window.matchMedia('(min-width: 48em)');
    this.accordions = selectArr('.accordion__title, .accordion__card--nav');
    this.accordionsMobile = selectArr('.accordion__mobile');
    this.initResize();
    this.initAccordion();
  }

  initAccordion() {
    const mouseMoveAccordion = (e) => {
      let accordion = selectDoc('.nav-list__link-parent.accordion.open');
      if(!childOf(e.target, accordion) && e.target !== accordion) {
        window.removeEventListener('mousemove', mouseMoveAccordion);
        removeClass(document.body, 'child-open');
        removeClass(accordion, 'open');
      }
    }

    this.accordions.forEach(accordion => {
      // ada : support keyboard
      ['click', 'keypress', 'mouseover'].forEach(e0 => {
        accordion.addEventListener(e0, e => {
          // if not mobile init accordion
          const key = e.keyCode;
          if ((key === 13 || e.type === 'click' || e.type === 'mouseover')
              && window.innerWidth > 768
          ) {
            const parent = accordion.parentNode;

            if(e.type === 'mouseover') {
              addClass(parent, 'open');
              event(window, 'mousemove', mouseMoveAccordion)
            } else {
              toggleClass(parent, 'open');
            }

            if(hasClass(parent, 'open')) {
              //Close open other nav components
              //Search
              if(hasClass(selectDoc('#ctaSearch'),'open')) {
                toggleSearch(false);
              }
              //My account
              if (hasClass(selectDoc('#ws-account'), 'show')) {
                toggleMiniAccount(false);
              }
              //Cart
              if(hasClass(selectDoc('#ws-minicart'), 'show')) {
                toggleMiniCart(false);
              }
              addClass(document.body, 'child-open');
            } else {
              removeClass(document.body, 'child-open');
            }

            parent.parentNode
                .querySelectorAll('.open')
                .forEach(o => o !== e.target.closest('.accordion') ? o.classList.remove('open') : '');
          }
        });
      });
    });

    this.accordionsMobile.forEach(accordion => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        accordion.addEventListener(event, e => {
          const key = e.keyCode;
          if (key === 13 || e.type === 'click') {

            this.accordionsMobile.forEach(acc => {
              if(acc !== accordion) {
                acc.parentNode.style.maxHeight = `25px`;
                removeClass(acc.parentNode, 'accordion__mobile-open');
                removeClass(acc, 'accordion__mobile-open');
              }
            });

            let height = (selectArr('a.nav-list__link', accordion.parentNode).length + 1) * 35;
            if(!hasClass(accordion.parentNode, 'accordion__mobile-open')) {
              accordion.parentNode.style.maxHeight = `${height}px`;
            } else {
              accordion.parentNode.style.maxHeight = `25px`;
            }

            toggleClass(accordion.parentNode, 'accordion__mobile-open');
            toggleClass(accordion, 'accordion__mobile-open');
          }
        });
      });
    });
  }

  initResize() {
    // initial size check
    this.mql.addListener((e) => {
      if (e.matches) {
        // remove open class from any accordion item on resize
        this.accordions.forEach(accordion => {
          // remove open class
          removeClass(document.body, 'child-open');
          removeClass(accordion.parentNode, 'open');
        })
      }
    });
  }
}

const accordionInit = {
  init() {
    // if element exists init this class
    const accordionElem = [].slice.call(
      document.querySelectorAll('.accordion')
    );
    if (accordionElem.length > 0) {
      const accordionWrap = new Accordion();
    }
  },
};

export default accordionInit;
